import * as React from "react";
import { getPaymentSelectOptions } from "../../../../../../../../utils/modules/PaymentMethodsList/utils/get-payment-select-options.js";
import { OneyContainer } from "../../../../../../../../containers/Adyen/Oney/containers/modules/PaymentMethodsList/containers/Adyen/Oney/containers/OneyContainer.js";
const Oney = ({ config, onChange }) => {
  const oneyOptions = React.useMemo(() => getPaymentSelectOptions(config), [config]);
  const onHandleChange = React.useCallback(
    (selectedInstallment) => {
      if (selectedInstallment.label && selectedInstallment.value) {
        onChange(
          {
            type: selectedInstallment.value
          },
          true
        );
      } else {
        onChange({}, false);
      }
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(OneyContainer, { options: oneyOptions, onChange: onHandleChange });
};
export {
  Oney
};
//# sourceMappingURL=Oney.js.map
